import { injectable } from '~/container'
import { Route } from './Route'

@injectable()
export abstract class RouterClient {
  abstract routeChanged(route: Route)
}
